export const authLoginModel = (data) => ({
    user: data.user ? {
        uuid: data.user.uuid,
        firstName: data.user.first_name,
        lastName: data.user.last_name,
        fullName: data.user.full_name,
        birthDate: data.user.birth_date,
        email: data.user.email,
        phoneCode: data.user.phoneCode,
        phone: data.user.phone,
        phoneIso: data.user.phone_iso,
        image: data.user.image,
        appAccess: data.user.appAccess,
        isSuperadmin: data.user.is_superadmin,
        appLastLoginAt: data.user.app_last_login_at,
        company: data.user.company ? {
            companyId: data.user.company.company_id ?? null,
            companyName: data.user.company.company_name ?? null,
            departmentId: data.user.company.department_id ?? null,
            departmentName: data.user.company.department_name ?? null,
            officeId: data.user.company.office_id ?? null,
        } : null,
    } : null,
    token: data.token ? {
        tokenType: data.token.token_type,
        accessToken: data.token.access_token,
        expiresIn: data.token.expires_in,
        // expiresAt: filtersHelper.getDateFormat(data.token.expires_at),
        expiresAt: data.token.expires_at,
        refreshExpiresIn: data.token.refresh_expires_in,
        // refreshExpiresAt: filtersHelper.getDateFormat(data.token.refresh_expires_at),
        refreshExpiresAt: data.token.refresh_expires_at,
    } : null
});